"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgCheckMark(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("path", { d: "M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1 1 0 111.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33z", "data-name": "checkmark" }))));
}
exports["default"] = React.forwardRef(SvgCheckMark);
//# sourceMappingURL=CheckMark.js.map